  <div class="page-control A4" id="pdf-report-page">
    <slot></slot>
  </div>